export const STATUS = [
  { value: 1, label: "Ready" },
  { value: 2, label: "Confirm" },
  { value: 3, label: "Picked" },
  { value: 4, label: "Packed" },
  { value: 5, label: "Checked Out" },
  { value: 6, label: "Complete" },
  { value: 7, label: "Waiting" },
  { value: 8, label: "Cancel" },
  { value: 9, label: "Return" },
  { value: 10, label: "Hold" },
  { value: 11, label: "Cancel-Ship" },
  { value: 12, label: "Shipping" },
  { value: 99, label: "Unoperate" },
];

export const DEPARTMENT = [
  { value: 0, label: "====== กรุณาเลือกระดับหน้าที่ ======" },
  { value: 1, label: "Admin" },
  { value: 2, label: "Zone" },
  { value: 3, label: "Worker" },
  { value: 4, label: "Viewer" },
  { value: 5, label: "Sub-Admin" },
];

export interface PackStation {
  id: number;
  value: string;
}

export const PACK_STATION: PackStation[] = [
  {
    id: 1,
    value: "1",
  },
  {
    id: 2,
    value: "2",
  },
  {
    id: 3,
    value: "3",
  },
  {
    id: 4,
    value: "4",
  },
  {
    id: 5,
    value: "5",
  },
  {
    id: 6,
    value: "6",
  },
  {
    id: 7,
    value: "7",
  },
  {
    id: 8,
    value: "8",
  },
  {
    id: 9,
    value: "9",
  },
  {
    id: 10,
    value: "10",
  },
  {
    id: 11,
    value: "11",
  },
  {
    id: 12,
    value: "12",
  },
  {
    id: 13,
    value: "13",
  },
  {
    id: 14,
    value: "14",
  },
  {
    id: 15,
    value: "15",
  },
  {
    id: 16,
    value: "16",
  },
  {
    id: 17,
    value: "17",
  },
  {
    id: 18,
    value: "18",
  },
  {
    id: 19,
    value: "19",
  },
  {
    id: 20,
    value: "20",
  },
];

export interface LogisticOption {
  label: string;
  value: string;
}

export type LogisticMaster = {
  [platformId: number]: string[]; // array of logistic VALUES allowed
};

export const ALL_LOGISTICS: LogisticOption[] = [
  { label: "Express Delivery (SHP Food)", value: "Express Delivery (SHP Food)" },
  { label: "Express Delivery (SPX)", value: "Express Delivery (SPX)" },
  { label: "Instant Delivery - 30m", value: "Instant Delivery - 30m" },
  { label: "Instant Delivery - 2h", value: "Instant Delivery - 2h" },
  { label: "Same day - J&T Express", value: "Same day - J&T Express" },
];

export const LOGISTIC_MASTER: LogisticMaster = {
  8: [
    "Express Delivery (SHP Food)",
    "Express Delivery (SPX)",
    "Instant Delivery - 30m",
    "Instant Delivery - 2h",
  ], // Shopee

  9: ["Same day - J&T Express"], // TikTok
};

export interface Platform {
  platf_id: number;
  platf_name: string;
}

export const PLATFORM_DELIVERY: Platform[] = [
  {
    platf_id: 8,
    platf_name: "Shopee",
  },
  {
    platf_id: 9,
    platf_name: "Tiktok",
  },
];
